import type { SVGProps } from "react";

export const ShinyIcon = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="50"
		height="50"
		viewBox="9 5 50 50"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M40.5227 11.6475C40.7506 10.5967 42.2494 10.5967 42.4773 11.6475L42.9673 13.9075C43.0504 14.2906 43.3496 14.5898 43.7327 14.6729L45.9928 15.163C47.0436 15.3908 47.0436 16.8897 45.9928 17.1175L43.7327 17.6076C43.3496 17.6906 43.0504 17.9899 42.9673 18.373L42.4773 20.633C42.2494 21.6838 40.7506 21.6838 40.5227 20.633L40.0327 18.373C39.9496 17.9899 39.6504 17.6906 39.2673 17.6076L37.0072 17.1175C35.9564 16.8897 35.9564 15.3908 37.0072 15.163L39.2673 14.6729C39.6504 14.5898 39.9496 14.2906 40.0327 13.9075L40.5227 11.6475ZM36.5304 31.1862C36.5304 31.1868 36.5296 31.187 36.5294 31.1864L32.3294 20.5881C32.0937 19.991 31.193 19.991 30.9513 20.5881L26.7322 31.1946C26.6596 31.3693 26.5145 31.5101 26.3332 31.5833L16.4443 35.5037C15.8519 35.7403 15.8519 36.5233 16.4443 36.7599L26.3272 40.6859C26.5145 40.7592 26.6596 40.9 26.7261 41.0802L30.9331 51.6924C31.1689 52.2895 32.0695 52.2895 32.3113 51.6924L36.5244 41.0971C36.5969 40.9169 36.748 40.7704 36.9414 40.6972L47.5376 36.7824C48.1541 36.5514 48.1541 35.7403 47.5376 35.5094L36.9475 31.5833C36.755 31.5104 36.6044 31.3706 36.5314 31.186C36.5312 31.1855 36.5304 31.1856 36.5304 31.1862ZM48.5888 22.1405C48.462 21.4945 47.538 21.4945 47.4112 22.1405L47.1754 23.3424C47.1284 23.5816 46.9414 23.7687 46.7021 23.8156L45.5002 24.0515C44.8543 24.1782 44.8543 25.1023 45.5002 25.229L46.7021 25.4649C46.9414 25.5118 47.1284 25.6989 47.1754 25.9381L47.4112 27.14C47.538 27.786 48.462 27.786 48.5888 27.14L48.8246 25.9381C48.8716 25.6989 49.0586 25.5118 49.2979 25.4649L50.4998 25.229C51.1457 25.1023 51.1457 24.1782 50.4998 24.0515L49.2979 23.8156C49.0586 23.7687 48.8716 23.5816 48.8246 23.3424L48.5888 22.1405Z"
				fill="url(#paint0_linear_424_2737)"
			/>
		</g>
		<defs>
			<filter
				id="filter0_di_424_2737"
				x="-18"
				y="-19.1406"
				width="102.984"
				height="109.281"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="17" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.65293 0 0 0 0 0.65293 0 0 0 0 0.65293 0 0 0 1 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_424_2737"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_424_2737"
					result="shape"
				/>
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="2" />
				<feGaussianBlur stdDeviation="1" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
				/>
				<feBlend
					mode="normal"
					in2="shape"
					result="effect2_innerShadow_424_2737"
				/>
			</filter>
			<linearGradient
				id="paint0_linear_424_2737"
				x1="14.9"
				y1="7.84633"
				x2="38.0002"
				y2="44.6962"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.395" stopColor="#FFC85B" />
				<stop offset="0.625" stopColor="#CD8C8A" />
				<stop offset="1" stopColor="#7B93D5" />
			</linearGradient>
		</defs>
	</svg>
);
